import { render, staticRenderFns } from "./AdminProductUpdate.vue?vue&type=template&id=25edbf46"
import script from "./AdminProductUpdate.vue?vue&type=script&lang=js"
export * from "./AdminProductUpdate.vue?vue&type=script&lang=js"
import style0 from "./AdminProductUpdate.vue?vue&type=style&index=0&id=25edbf46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports